import { type Padding, type PaddingWithUnit } from '@xyflow/system';

import { useChatSidebarStore } from '@air/feature-ag-ui-chat';

import { CHAT_SIDEBAR_WIDTH_CSS_VAR } from '../constants';

const LEFT_RIGHT_PADDING = 32;
const TOOLBAR_GAP = 24;
const TOOLBAR_HEIGHT = 48;
const FIT_VIEW_BUFFER_PX = TOOLBAR_GAP + TOOLBAR_HEIGHT * 2;
const FIT_VIEW_BUFFER: PaddingWithUnit = `${FIT_VIEW_BUFFER_PX}px`;

/**
 * Returns fitView padding that accounts for the chat sidebar when it's open.
 * Reads the `--chat-sidebar-width` CSS variable set by SidebarResizer — if
 * present the right padding is increased so nodes aren't hidden behind the panel.
 * Falls back to uniform padding when the variable is absent (panel closed, SSR).
 */
export const getFitViewPadding = (): Padding => {
  if (typeof document !== 'undefined' && useChatSidebarStore.getState().open) {
    const chatWidth = document.documentElement.style.getPropertyValue(CHAT_SIDEBAR_WIDTH_CSS_VAR);

    if (chatWidth) {
      return {
        bottom: FIT_VIEW_BUFFER,
        left: `${LEFT_RIGHT_PADDING}px`,
        right: `${LEFT_RIGHT_PADDING + parseInt(chatWidth, 10)}px`,
        top: FIT_VIEW_BUFFER,
      };
    }
  }

  return {
    bottom: FIT_VIEW_BUFFER,
    left: `${LEFT_RIGHT_PADDING}px`,
    right: `${LEFT_RIGHT_PADDING}px`,
    top: FIT_VIEW_BUFFER,
  };
};
